<template>
  <div class="main-container">

    <router-view></router-view>
    <!-- Navbar section -->
    <!-- Navbar section -->
    <!-- breadcrumb strat -->
    <Breadcrumb>
      <template slot="breadcrumb">

        <div class="breadcrumb_box text-center">
          <h3 class="breadcrumb-title">Top cpu entries in text form </h3>
          <!-- breadcrumb-list start -->
          <ul class="breadcrumb-list">

            <li class="breadcrumb-item active">gh</li>
            <li class="breadcrumb-item">
              <router-link :to="{name:'HomeBranding'}">{{ $route.params.org }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{name:'HomeBranding'}">{{ $route.params.repo }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{name:'HomeBranding'}">{{ $route.params.commit }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{name:'HomeBranding'}">benchmark = {{ $route.params.bench }}</router-link>
            </li>
            <li class="breadcrumb-item active">CPU</li>

          </ul>
          <!-- breadcrumb-list end -->
        </div>

      </template>
    </Breadcrumb>
    <!-- breadcrumb end -->

    <b-card-header header-tag="nav">
      <b-nav card-header tabs>
        <b-nav-item :to="{name:'top-cpu-functions'}" :active='$route.name =="top-cpu-functions" || $route.name =="top-cpu"'>CPU by Function</b-nav-item>
        <b-nav-item :to="{name:'top-cpu-lines'}" :active='$route.name =="top-cpu-lines"'>CPU by LOC</b-nav-item>
        <b-nav-item :to="{name:'cpu-flamegraph'}" :active='$route.name =="cpu-flamegraph"'>FlameGraph</b-nav-item>
      </b-nav>
    </b-card-header>

    <!-- blog item wrapper start -->
    <div class="blog-pages-wrapper section-space--ptb_30 border-bottom">
      <div class="container">
        <h5 >Table granularity: {{granularity}}</h5>
        <div class="row">
          <div class="col-lg-12">
            <v-data-table
                :page="page"
                :pageCount="numberOfPages"
                :headers="headers"
                :items="rows"
                :options.sync="options"
                :server-items-length="totalRows"
                :loading="loading"
                class="elevation-1"
            >
            </v-data-table>
          </div>
        </div>
        </div>
        </div>
    <!-- footer section -->
    <FooterMain />

  </div>
</template>

<script>

import axios from "axios";
import FooterMain from "../components/FooterMain";
import Breadcrumb from "../components/Breadcrumb";

export default {
  name: "DatatableComponent",
  components: {
      FooterMain,
    Breadcrumb,
},
  props: {
    granularity: {
      type: String,
      default: "functions",
    }
  },
  data() {
    return {
      page: 0,
      totalRows: 0,
      numberOfPages: 0,
      rows: [],
      loading: true,
      options: {},
      headers: [
        {text: "Flat %", value: "flat%"},
        {text: "Cum %", value: "cum%"},
        {text: "Symbol", value: "symbol"},
      ],
    };
  },
  //this one will populate new data set when user changes current page.
  watch: {
    options: {
      handler() {
        this.readDataFromAPI();
      },
    },
    deep: true,
  },
  methods: {
    //Reading data from API method.
    readDataFromAPI() {
      let parameters = this.$route.params;
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      let pageNumber = page - 1;
      if (pageNumber < 0 ){
        pageNumber = 0;
      }
      let end = process.env.VUE_APP_API_CODEPERF_IO_URL;
      let u = process.env.VUE_APP_API_CODEPERF_IO_USERNAME;
      let p = process.env.VUE_APP_API_CODEPERF_IO_PASSWORD;
      axios
          .get(
              end + "/v1/gh/" +
              parameters.org + "/" + parameters.repo + "/commit/" + parameters.commit
              + "/bench/" + parameters.bench
              + "/cpu/"+this.granularity+"?size=" +
              itemsPerPage +
              "&page=" +
              pageNumber,
              {
                auth: {
                  username: u,
                  password: p
                }
              })
          .then((response) => {
            //Then injecting the result to datatable parameters.
            this.loading = false;
            this.rows = response.data.data;
            this.totalRows = response.data.totalRows;
            this.numberOfPages = response.data.totalPages;
          })
          .catch(error => {
            this.loading = false;
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              // console.log(error.response.data);
              // console.log(error.response.status);
              // console.log(error.response.headers);
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              //console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              //console.log('Error', error.message);
            }
          });
    },
  },
};

</script>
